import {
  contextIsAvailable,
  extractTrackingPageContext,
} from '@aboutyou/legacy-shared/src/tracking/hooks/trackingHelpers'
import { trackAyCustomerDataOnce } from '@aboutyou/legacy-shared/src/tracking/utils/trackAyCustomerDataOnce'
import { StoryDetailPageContext } from '@aboutyou/legacy-tracking-sdk'
import { exists } from 'helpers/exists'
import { useLegacyCustomerDataForAyTracking } from 'helpers/tracking/hooks/useLegacyCustomerDataForAyTracking'
import { useTracking } from 'helpers/tracking/hooks/useTrackingContextAndClientV6'
import { useObserver } from 'mobx-react-lite'
import React, { FC, useEffect, useRef } from 'react'
import { useHistory } from 'react-router'
import { useStoryPageStore } from 'store/context'

function useTrackStoryPageView(pageTitle: string) {
  const { pageContext, TrackingClient } = useTracking()
  const storyPageStore = useStoryPageStore()
  const story = useObserver(() => storyPageStore.story)
  const customerDataPayload = useLegacyCustomerDataForAyTracking()
  const tracked = useRef(false)
  const {
    location: { pathname },
  } = useHistory()

  useEffect(() => {
    if (tracked.current) {
      return
    }

    if (
      exists(customerDataPayload) &&
      story &&
      contextIsAvailable(pageContext) &&
      !pageContext.disabled &&
      Number(story.id) === pageContext.id &&
      // Makes sure to track the content view only when the pageContext has the info for the correct path, since the redial send the info for the new page delayed
      pathname === pageContext.path
    ) {
      const page = extractTrackingPageContext(pageContext)

      tracked.current = true
      trackAyCustomerDataOnce(TrackingClient, customerDataPayload)
      TrackingClient?.trackStoryView({
        page: { ...page, title: pageTitle } as StoryDetailPageContext,
        customer: customerDataPayload,
      })
    }
  }, [pageContext, exists(story), pageTitle, customerDataPayload?.type])
}

const TrackStoryPageView: FC<
  React.PropsWithChildren<{ pageTitle: string }>
> = ({ pageTitle, children }) => {
  useTrackStoryPageView(pageTitle)

  return <>{children}</>
}

export default TrackStoryPageView
